<template>
  <v-form
    ref="form"
    v-model="isFormValid"
    lazy-validation
  >
    <v-row justify="center">
      <a
        :href="appUrl"
        target="_blank"
      >
        <img
          alt="app-logo"
          height="150px"
          :src="appLogo"
        />
      </a>
    </v-row>

    <span
      class="h4 font-weight-light my-5"
      v-html="$t('views.signup_in.dont_have_account')"
    >
    </span>
    <span>
      <router-link
        to="/signup"
        class="text-decoration-underline ml-3"
        text
      >
        {{ $t("views.signup_in.signup") }}
      </router-link>
    </span>

    <v-text-field
      validate-on-blur
      v-model="email"
      name="email"
      :label="$t('commons.email')"
      :rules="rules.email"
      autofocus
      class="input-group--focused"
    />
    <v-text-field
      validate-on-blur
      v-model="password"
      name="password"
      :rules="rules.password"
      :type="passwordType"
      autocomplete="off"
      :label="$t('commons.pwd')"
      :append-icon="eyeIcon"
      @keyup.enter="submit"
      @click:append="togglePassword"
    />
    <v-btn
      large
      block
      :disabled="loading"
      :loading="loading"
      color="blue white--text"
      class="my-3"
      @click="submit"
    >
      {{ $t("views.signup_in.signin") }}
    </v-btn>
    <ForgottenPasswordDialog /><br />
    <ResendActivationEmail />
  </v-form>
</template>

<script>
import ForgottenPasswordDialog from "@/components/utils/ForgottenPasswordDialog.vue"
import ResendActivationEmail from "@/components/utils/ResendActivationEmail.vue"
import { required, email } from "@/utils/validator"
import { AccountService } from "@/services"
export default {
  components: {
    ForgottenPasswordDialog,
    ResendActivationEmail
  },
  data: function () {
    return {
      appLogo: this.$appConfig.assets.img.custom.logo,
      appUrl: this.$appConfig.url,
      loading: false,
      email: "",
      password: "",
      eyeIcon: "mdi-eye",
      passwordType: "password",
      isFormValid: false,
      rules: {
        email: [required, email],
        password: [required]
      }
    }
  },
  mounted: function () {
    this.$refs.form.reset()
  },
  methods: {
    submit() {
      if (this.loading) return
      this.$refs.form.validate()
      this.$nextTick(() => {
        if (this.isFormValid) {
          this.call_login()
        }
      })
    },
    call_login() {
      let credentials = {
        email: this.email,
        password: this.password
      }

      this.loading = true
      AccountService.login(this, credentials, this.$route.query.redirect).finally(() => {
        this.loading = false
      })
    },
    clear() {
      this.$refs.form.reset()
      this.email = ""
      this.password = ""
      this.checkbox = null
    },
    togglePassword() {
      this.passwordType = this.passwordType == "password" ? "text" : "password"
      this.eyeIcon = this.eyeIcon == "mdi-eye" ? "mdi-eye-off" : "mdi-eye"
    }
  }
}
</script>
